import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import { checkFootAuth, checkFootTitleAuth } from '../dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
import { checkExchange } from '../../controller/util.js';
import { LINE_TYPE } from '../setting.js';
const model = {
  psy: {
    Type: Array,
    Default: () => ([])
  },
  psyMa: {
    Type: Array,
    Default: () => ([])
  },
  params: {
    type: String,
    Default: 'PSY(12,6)'
  }
};
export default class PSYState extends FootDectorator(BaseContext) {
  constructor({ data, ...rest }) {
    super({ ...rest, data: mergeModelData(model, data) });
  }
  _calcRange() {
    let { psy, psyMa, code, params } = this.state.data
    let { maxValue, minValue } = this.calcRange({ data: [psy, psyMa], targetKey: 'value', isAdditional: true });
    // if (maxValue === minValue) {
    //   if (maxValue === 0) {
    //     maxValue = 1;
    //     minValue = -1;
    //   } else if (maxValue === 100) {
    //     maxValue = 150;
    //     minValue = 50;
    //   }
    // } else {
    //   const ratioVal = maxValue * 0.05;
    //   maxValue += ratioVal;
    //   minValue -= ratioVal;
    // }
    this.maxValue = maxValue;
    this.minValue = minValue;
  }
  _calcAxis() {
    const maxValue = this.maxValue;
    const range = maxValue * 2;
    const {
      height
    } = this.availArea;
    const ratio = height / range;
    const { psy, psyMa, start, end } = this.state.data
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({ data: psy });
    curryCalcAxis({ data: psyMa })
  }
  // 画主图
  _drawMain() {
    const {
      left,
      width,
      height,
      top,
      bottom,
    } = this.availArea;
    const { psy, psyMa, start, end } = this.state.data;
    const { LINE } = LINE_TYPE;
    const { psy: psyLine, psyMa: psyMaLine } = this.option.Psy
    this._drawLine(LINE, psy, left, bottom, psyLine.lineWidth, psyLine.color);
    this._drawLine(LINE, psyMa, left, bottom, psyMaLine.lineWidth, psyMaLine.color)

  }
  _drawAxisY() {
    const { axisY } = this.option.Psy;
    const {
      left,
      right,
      top,
      bottom,
      height
    } = this.availArea;
    const ctx = this.context;
    const maxValue = this.maxValue;
    const minValue = this.minValue;
    // const line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
    let line;
    if(maxValue>0&&minValue<0){
      line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
    }else if(maxValue<0&&minValue<0) {
      line=((Math.abs(minValue)-Math.abs(maxValue))/2+minValue).toFixed(2)
    }else {
      line=((Math.abs(maxValue)-Math.abs(minValue))/2+minValue).toFixed(2)
    }
    ctx.beginPath();
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillStyle = axisY.color;
    ctx.font = axisY.sizeRatio * this.state.baseSize * this.dpr + "px " + axisY.fontFamily;
    ctx.fillText(this.maxValue.toFixed(2), left, top+20);
    ctx.textBaseline = 'middle';
    ctx.fillText(line, left, top + height / 2);
    ctx.textBaseline = 'bottom';
    ctx.fillText(this.minValue.toFixed(2), left, bottom);
  }
  // @checkFootTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;

    //availArea是画布宽高，是一个对象
    const { top } = this.availArea;
    const { current, sealObj } = this.state.data;
    // this.state是一个对象，,height:高度，baseSize:最基本大小
    const { height, baseSize } = this.state;
    // ratioFixed的值为2
    const { ratioFixed } = sealObj;
    const { space } = this.option.Psy;
    const { baseLine } = this.option.FootContext.title;
    const baseLineY = top + height * baseLine;
    let { left } = this.availArea;
    // left+=ctx2.measureText(this.maxValue.toFixed(2)).width+10
    const {
      sizeRatio,
      fontFamily,
      axisY,
    } = this.option.Psy;

    [
      'params',
      'psy',
      'psyMa',
    ].forEach(val => {
      const data = this.state.data[val];
      if (data == 'PSY(12,6)') {
        let color = this.option.Psy.params.color
        ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
        ctx2.fillStyle = color;
        ctx2.textAlign = 'left';
        ctx2.textBaseline = 'top';
        ctx2.beginPath();
        const text = data
        const textWidth = ctx2.measureText(text).width;
        ctx2.fillText(text, left, baseLineY);
        left += textWidth+10;
      } else {
        if (Util.isArray(data)) {
          let color = this.option.Psy[val].color
          const item = data[current];
          ctx2.font = sizeRatio * baseSize * this.dpr + 'px' + fontFamily
          ctx2.fillStyle = color;
          ctx2.textAlign = 'left'
          ctx2.textBaseline = 'top';
          ctx2.beginPath();
          if (Util.isDef(item) && Util.isValidNumber(item.value)) {
            // 吧字符串转换为大写
            const text = val.toUpperCase() + ':' + item.value.toFixed(ratioFixed);
            const textWidth = ctx2.measureText(text).width
            ctx2.fillText(text, left, baseLineY);
            left += textWidth

          } else {
            const text = val.toUpperCase() + ': -';
            const textWidth = ctx2.measureText(text).width;
            ctx2.fillText(text, left, baseLineY);
            left += textWidth;
          }
          left += space * this.dpr
        }
      }
    })

  }

}
